const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const unescape = require('lodash/string/unescape');

// @utils
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE,
    TYPE_STOCKS
} = require('constants/index');

// @components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

class StocksFilters extends React.Component {
    constructor(props) {
        super(props);

        this.handleMarketChange = this.handleMarketChange.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.handleTermInputChange = this.handleTermInputChange.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    componentDidMount() {
        const { searchState } = this.props;
        const term = searchState.getIn(['selectedValues', TYPE_STOCKS, 'term']);

        if (term) {
            this.handleProductChange(term);
        }
    }

    adaptMarketsOptions(options) {
        options = options.toJS();
        return [
            {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsM')},
            ...options.map(item => {
                return {value: item.isoCode, label: unescape(item.exchangeName), complete: item};
            })
        ];
    }

    handleMarketChange(market) {
        this.props.onHandleFieldChange('market', market);
    }

    handleProductChange(value) {
        if (value !== ' ') {
            this.props.onHandleFieldChange('term', value);
        }
    }

    handleProductSelect(ev) {
        if (ev.id) {
            this.props.onHandleFieldChange('term', ev.id.isin);
            this.props.onHandleFieldChange('selectedProduct', ev.value);
        } else {
            this.props.onHandleFieldChange('term', '');
            this.props.onHandleFieldChange('selectedProduct', '');
        }
    }

    handleTermInputChange(event) {
        this.handleProductChange(event.target.value);
    }

    render() {

        const { searchState } = this.props;
        const markets = this.adaptMarketsOptions(searchState.getIn(['filters', TYPE_STOCKS, 'markets']));
        const activeMarket = searchState.getIn(['selectedValues', TYPE_STOCKS, 'market']);
        const nameInputLabel = formatText('broker-advancedSearchNameIsinTickerLabel');
        const term = searchState.getIn(['selectedValues', TYPE_STOCKS, 'term']);
        const errorMessage = formatText('broker-advancedSearchNameIsinTickerLabelErrorMessage');

        return (
            <div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <label className="broker-advanced-search-explore__label">
                            {nameInputLabel}
                        </label>
                        <InputSafe
                            id="inpBrokerAdvancedSearchTerm"
                            name="advanced-search-name"
                            value={term}
                            onChange={this.handleTermInputChange}
                            type="text"
                            errorState={!this.props.validation.stocksNameValid}
                            errorMessage={errorMessage}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchMarket"
                            label="broker-advancedSearchMarketLabel"
                            name="advanced-search-market"
                            options={markets}
                            value={activeMarket}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleMarketChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

StocksFilters.propTypes = {
    showAdditionalFilters: PropTypes.bool,
    searchState: PropTypes.object.isRequired,
    searchSimpleState: PropTypes.object.isRequired,
    onHandleFieldChange: PropTypes.func.isRequired,
    onHandleProductChange: PropTypes.func.isRequired,
    onHandleSearchReset: PropTypes.func.isRequired,
    onHandleToggleAdditionalFilters: PropTypes.func,
    validation: PropTypes.object.isRequired
}

module.exports = StocksFilters;